const config = {
  name: "$dadata",
  suggest: "https://suggestions.dadata.ru/suggestions/api/4_1/rs/",
  token: "",
};

export default config;
